// BidHistory.js
import React from "react";
import "./BidHistory.css";
import { useSelector,useDispatch } from "react-redux";
import { get_all_depends } from "../features/userSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { useT } from "../i18n";

const AccountHistory = () => {
    const { isUserLogedIn,Info,Wallet_history } = useSelector((state) => state.users);
    const dispatch=useDispatch();
    const { t } = useT();
    React.useEffect(()=>{

      if(isUserLogedIn){
        let data = new FormData();
        data.append('phone_number',Info?.phone_number);
        dispatch(get_all_depends({request_type:'get_wallet_history',data:data}));
      }
     },[isUserLogedIn,Info?.phone_number,dispatch])

     const refine_amount=(transAmount,updatedAmount,TYEP,remark)=>{
              // Remove '+' or '-' sign and convert to number
              const transactionAmount = parseFloat(transAmount.replace(/[+-]/g, ''));

              // Determine the sign of the transaction
              const isDeposit = transAmount.startsWith('+');
           if(TYEP==='TAG'){
               if(isDeposit || remark==='Welcome Bonus'){
                let remarksss=remark==='Welcome Bonus'?'+':'';
                return <span>{`${remarksss}${transAmount}`}</span> ;
               }else{
                return <span>{`-${transAmount.replace(/^[+-]/, '')}`}</span> ;
               }
           } 

              // Calculate previous amount based on transaction type
              if (isDeposit || remark==='Welcome Bonus') {
              return parseInt(updatedAmount) - transactionAmount;
              } else {
              return parseInt(updatedAmount) + transactionAmount;
              }
     }


     function formatDate(dateString) {
      const date = new Date(dateString);
      const options = { day: 'numeric', month: 'short', year: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    }

  return (
    <div className="fh-screen">
      {Wallet_history.map((bid, index) => {
        const isCredit = bid.amount?.startsWith('+') || bid.remark==='Welcome Bonus' || bid.remark==='Welcome Bonus.';
        return (
          <div className="fh-card" key={index}>
            <span className={`fh-icon${isCredit?'':' out'}`}><FontAwesomeIcon icon={isCredit?faArrowDown:faArrowUp} /></span>
            <div className="fh-main">
              <strong>{bid.remark}</strong>
              <span>{formatDate(bid.date)}</span>
              <span>{t('Balance')}: ₹{refine_amount(bid.amount,bid.updated_amount,'CAL',bid.remark)} → ₹{bid.updated_amount}</span>
            </div>
            <div className="fh-side">
              <strong className={isCredit?'in':'out'}>{refine_amount(bid.amount,bid.updated_amount,'TAG',bid.remark)}</strong>
            </div>
          </div>
        );
      })}
      {Wallet_history.length===0 && <p className="bet-empty">{t("No transactions yet")}</p>}
    </div>
  );
};

export default AccountHistory;
